import { createWorkerAction } from '../../lib';

export const resizeWindow = createWorkerAction('RESIZE_WINDOW');
